import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import retry from '../../../utils/chunkRetry';
import type { CommentEditorProps } from './types';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "editor_v3", webpackPrefetch: true */
        './Comment'
      )
  )
);

const CommentEditorLoadable: React.FC<
  CommentEditorProps & {
    loadingIndicator?: React.ReactNode;
  }
> = ({ loadingIndicator, ...rest }) => {
  return (
    <EditorLoadableWrapper fallback={loadingIndicator}>
      <LoadableEditor {...rest} />
    </EditorLoadableWrapper>
  );
};
CommentEditorLoadable.displayName = 'CommentEditor';

export default CommentEditorLoadable;
